import { z } from 'zod';
import { moneySchema } from '../money';

/**
 * Projekt-Controlling als Plan-vs-Ist-Vergleich (Vor-/Nachkalkulation, ADR 0016).
 * Material gegliedert nach Hauptwarengruppe, Stunden nach Position. Abweichung =
 * Plan − Ist (negativ = überzogen).
 */
const currencySchema = z.enum(['EUR', 'USD', 'CHF']);

export const controllingMaterialRowSchema = z.object({
  mainGroupCode: z.number().int(),
  /** Name aus den Hauptwarengruppen-Stammdaten; null, wenn (noch) nicht benannt. */
  mainGroupName: z.string().nullable(),
  plan: moneySchema,
  actual: moneySchema,
  variance: moneySchema,
});
export type ControllingMaterialRow = z.infer<typeof controllingMaterialRowSchema>;

export const controllingLaborRowSchema = z.object({
  positionId: z.string().uuid().nullable(),
  positionName: z.string(),
  plannedHours: z.number(),
  actualHours: z.number(),
  plan: moneySchema,
  actual: moneySchema,
  variance: moneySchema,
});
export type ControllingLaborRow = z.infer<typeof controllingLaborRowSchema>;

export const controllingTotalsSchema = z.object({
  plan: moneySchema,
  actual: moneySchema,
  variance: moneySchema,
});
export type ControllingTotals = z.infer<typeof controllingTotalsSchema>;

export const projectControllingResponseSchema = z.object({
  projectId: z.string().uuid(),
  currency: currencySchema,
  material: z.object({
    rows: z.array(controllingMaterialRowSchema),
    totals: controllingTotalsSchema,
  }),
  labor: z.object({
    rows: z.array(controllingLaborRowSchema),
    totals: controllingTotalsSchema,
  }),
  /** Gesamt = Material + Stunden. */
  totals: controllingTotalsSchema,
});
export type ProjectControllingResponse = z.infer<typeof projectControllingResponseSchema>;
